import React, { Component } from 'react'

class Grafana extends Component {
    render() {
        return (
            <iframe
                src="https://snapshot.raintank.io/dashboard/snapshot/W3UcIj0O4UC8s332VElkrMZrTndT5kXi?orgId=2"
                style={{ position: 'fixed', left: 0, right: 0, bottom: 0, top: 0, height: "100%", width: "100%", border: 'none' }}
            ></iframe>
        )
    }
}

export default Grafana;